import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'ramda';
import { ThemeProvider } from 'styled-components';
import {
  Container,
  IconWrapper,
  FilterButton,
  SubmitButton,
  InnerContainer,
  ScrollableContainer,
} from './filtersBar.styles';
import { renderWhenTrue, renderWhenTrueOtherwise } from '../../utils/rendering';
import { HiddenOnPlatform } from '../hiddenOnPlatform';
import messages from './filtersBar.messages';
import { Icon, ICON_DOWN, ICON_ARROW_RIGHT } from '../icon';
import { colors } from '../../../theme/styled';
import { FilterNames } from '../../../modules/filters/filters.constants';

const renderIcon = (
  iconProps = { name: ICON_DOWN, stroked: true, borderColor: colors.middleGray },
  isPrimary = false,
  iconOnly = false
) =>
  renderWhenTrueOtherwise(
    () => (
      <IconWrapper>
        <Icon {...iconProps} primary={isPrimary} />{' '}
      </IconWrapper>
    ),
    () => (
      <HiddenOnPlatform mobile mobileBig tabletPortrait>
        <IconWrapper>
          <Icon {...iconProps} primary={isPrimary} />
        </IconWrapper>
      </HiddenOnPlatform>
    )
  )(iconOnly);

export const FiltersBarComponent = ({
  submitFilters,
  availableFilters,
  filtersQuery,
  currentFilterName,
  animateModalByFilterName,
  withSubmitButton,
  className,
  selectedMarketId,
  categoriesData,
}) => {
  const hasAnyCategories = !isEmpty(categoriesData[selectedMarketId]);

  const renderSubmitButton = () => (
    <SubmitButton
      primary
      message={messages.search}
      onClick={() => {
        submitFilters(filtersQuery);
      }}
      renderIcon={() => renderIcon({ name: ICON_ARROW_RIGHT, size: 11 }, undefined, true)}
    />
  );

  return (
    <ThemeProvider theme={{ withSubmitButton }}>
      <Container className={className}>
        <InnerContainer>
          <ScrollableContainer withSubmitButton={withSubmitButton}>
            {availableFilters.map(filter => (
              <ThemeProvider key={filter.name} theme={{ customLabel: !isEmpty(filter.label) }}>
                <FilterButton
                  disabled={filter.name === FilterNames.ACTIVITIES && (!selectedMarketId || !hasAnyCategories)}
                  primary={currentFilterName === filter.name}
                  placeholderMessage={messages[filter.name]}
                  message={filter.label}
                  onClick={() => animateModalByFilterName(filter.name)}
                  renderIcon={() => renderIcon(undefined, currentFilterName === filter.name)}
                />
              </ThemeProvider>
            ))}
            {renderWhenTrue(() => <HiddenOnPlatform below="tabletPortrait">{renderSubmitButton()}</HiddenOnPlatform>)(
              withSubmitButton
            )}
          </ScrollableContainer>
        </InnerContainer>
        {renderWhenTrue(() => <HiddenOnPlatform above="tablet">{renderSubmitButton()}</HiddenOnPlatform>)(
          withSubmitButton
        )}
      </Container>
    </ThemeProvider>
  );
};

export const FiltersBar = memo(FiltersBarComponent);

FiltersBarComponent.propTypes = {
  submitFilters: PropTypes.func.isRequired,
  filtersQuery: PropTypes.string,
  className: PropTypes.string,
  selectedMarketId: PropTypes.string,
  availableFilters: PropTypes.arrayOf(PropTypes.object).isRequired,
  animateModalByFilterName: PropTypes.func.isRequired,
  currentFilterName: PropTypes.string.isRequired,
  categoriesData: PropTypes.object.isRequired,
  withSubmitButton: PropTypes.bool,
};

FiltersBarComponent.defaultProps = {
  withSubmitButton: false,
};
